<template>
  <div class="youtube-player">
    <div ref="youtubePlayer"></div>
  </div>
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      required: true,
    },
    autoplay: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      player: null,
      timer: null,
    };
  },
  mounted() {
    this.initPlayer();
  },
  methods: {
    initPlayer() {
      if (!document.querySelector('script[src="https://www.youtube.com/iframe_api"]')) {
        const tag = document.createElement("script");
        tag.src = "https://www.youtube.com/iframe_api";
        document.head.appendChild(tag);

        window.onYouTubeIframeAPIReady = () => {
          this.startVideo();
        };
      } else {
        this.startVideo();
      }
    },
    startVideo() {
      this.player = new YT.Player(this.$refs.youtubePlayer, {
        videoId: this.getVideoId(),
        playerVars: {
          autoplay: this.autoplay ? 1 : 0,
          modestbranding: 1,
          showinfo: 0,
          rel: 0,
        },
        events: {
          onStateChange: this.onPlayerStateChange,
        },
      });
    },
    getVideoId() {
      const url = new URL(this.src);

      if (url.pathname.startsWith("/embed/")) {
        return url.pathname.split("/")[2];
      }

      return url.searchParams.get("v");
    },
    onPlayerStateChange(event) {
      if (event.data === YT.PlayerState.PLAYING) {
        this.player.addEventListener("onTimeUpdate", () => {
          const currentTime = this.player.getCurrentTime();
          const duration = this.player.getDuration();
          const progress = Math.round((currentTime / duration) * 100);
          this.$emit("onProgress", { progress });
        });
      } else if (event.data === YT.PlayerState.ENDED) {
        this.$emit("onProgress", { progress: 100 });
      }
    },
  },
};
</script>

<style>
.youtube-player {
  position: relative;
  width: 100%;
  padding-bottom: 56.25%;
}

.youtube-player iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
